<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row">
    <div class="col-lg-6">
      <autocomplete
        [clearable]="false"
        [placeholder]="'CONTRACT.PROVIDER' | translate"
        [url]="providerService.getAll.bind(providerService)"
        formControlName="providerId"
        bindLabel="name"
        inputValidator
        label="CONTRACT.PROVIDER"
      >
      </autocomplete>
    </div>
    <div class="col-lg-6">
      <autocomplete
        [clearable]="false"
        [placeholder]="'CONTRACT.METER' | translate"
        [url]="meterService.getAll.bind(meterService)"
        formControlName="meterId"
        bindLabel="name"
        inputValidator
        label="CONTRACT.METER"
      >
      </autocomplete>
    </div>

    <div class="col-lg-6">
      <autocomplete
        [clearable]="false"
        [placeholder]="'CONTRACT.TARIFF' | translate"
        [url]="tariffService.getAll.bind(tariffService)"
        formControlName="tariffId"
        bindLabel="name"
        inputValidator
        label="CONTRACT.TARIFF"
      >
      </autocomplete>
    </div>

    <div class="col-lg-6">
      <autocomplete
        [clearable]="false"
        [placeholder]="'CONTRACT.UTILITY_RATE' | translate"
        [url]="utilityRateService.getAll.bind(utilityRateService)"
        [params]="{ utilityType: type }"
        formControlName="utilityRateId"
        bindLabel="price"
        inputValidator
        label="CONTRACT.UTILITY_RATE"
      >
      </autocomplete>
    </div>

    <div class="col-lg-6">
      <p-inputNumber
        [useGrouping]="false"
        mode="decimal"
        class="w-100"
        styleClass="w-100"
        inputStyleClass="form-control"
        formControlName="taxRatePercent"
        inputValidator
        [minFractionDigits]="0"
        [maxFractionDigits]="5"
        [placeholder]="'CONTRACT.TAX_RATE_PERCENT' | translate"
        label="CONTRACT.TAX_RATE_PERCENT"
      />
    </div>
    <div class="col-lg-6">
      <p-inputNumber
        [useGrouping]="false"
        mode="decimal"
        class="w-100"
        styleClass="w-100"
        inputStyleClass="form-control"
        formControlName="taxRateAmount"
        inputValidator
        [minFractionDigits]="0"
        [maxFractionDigits]="5"
        [placeholder]="'CONTRACT.TAX_RATE_AMOUNT' | translate"
        label="CONTRACT.TAX_RATE_AMOUNT"
      />
    </div>

    <div class="col-lg-6">
      <datepicker
        [placeholder]="'CONTRACT.START_DATE' | translate"
        formControlName="startDate"
        inputValidator
        label="CONTRACT.START_DATE"
        inputStyleClass="form-control"
      ></datepicker>
    </div>
    <div class="col-lg-6">
      <datepicker
        [placeholder]="'CONTRACT.END_DATE' | translate"
        formControlName="endDate"
        inputValidator
        label="CONTRACT.END_DATE"
        inputStyleClass="form-control"
      ></datepicker>
    </div>
    <div class="col-lg-6">
      <datepicker
        [placeholder]="'CONTRACT.TERMINATED_AT' | translate"
        formControlName="terminatedAt"
        inputValidator
        label="CONTRACT.TERMINATED_AT"
        inputStyleClass="form-control"
      ></datepicker>
    </div>

    <div class="col-lg-6">
      <input
        [placeholder]="'CONTRACT.NUMBER' | translate"
        class="form-control"
        formControlName="number"
        inputValidator
        label="CONTRACT.NUMBER"
        type="text"
      />
    </div>
    <div class="col-12">
      <div class="form-check form-switch mt-2">
        <input class="form-check-input" formControlName="status" role="switch" type="checkbox">
        <label class="form-check-label">{{ 'CONTRACT.STATUS' | translate }}</label>
      </div>
    </div>
    <div class="text-end d-flex justify-content-end gap-2 mt-3">
      <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
      <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
    </div>
  </div>
</form>
